import type { Remote } from "comlink"
import { CatalogConnection } from "./catalog-connection"
import type { CatalogWorker } from "./catalog.worker"
import { getOpfsPathSegments } from "@/utils/opfs-path"
import { findExistingCatalogFileName } from "./catalog-file-name"

export type { CatalogWorker } from "./catalog.worker"
export type * from "./types"
export { createPhotoRecord, getDefaultAdjustmentHistory } from "./utils"

export const CatalogManager: Remote<CatalogWorker> = await CatalogConnection.connect()

export async function openCatalogDirectory(handle: FileSystemDirectoryHandle) {
	// Check if this is an OPFS-backed directory (has path segments).
	// If so, we can pass path segments to the worker instead of the handle,
	// which works around Safari's inability to transfer FileSystemDirectoryHandle.
	const opfsPathSegments = getOpfsPathSegments(handle)

	if (opfsPathSegments && opfsPathSegments.length > 0) {
		console.log("[Catalog] Opening via OPFS path segments", opfsPathSegments)
		try {
			await CatalogManager.openFromOpfsPath(opfsPathSegments)
			return
		} catch (error) {
			console.warn("[Catalog] Failed to open via OPFS path, falling back", error)
			// Fall through to try the normal approach
		}
	}

	await CatalogManager.open(handle)
}

export async function catalogExists(handle: FileSystemDirectoryHandle) {
	return (await findExistingCatalogFileName(handle)) !== null
}
